/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */

import {
  Component, Model, Vue, Watch,
} from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { Popup } from 'vant';
import { Toast } from '@hb/coffee';

import type { Commodity } from '@/api/contract/types';
import type {
  LoanUsageOption, ApplyChannelData, ProductCapitalItem,
} from '@/api/apply-product/types';
import ForceReadBtn, { ButtonTypeEnum } from '@/components/force-read-btn';
import { shouldShowPartialLoanTip } from '../../utils/partial-loan';

import MultiChannelContracts from '../multi-channel-contracts';

import style from './index.module.scss';


const ApplyProductStore = namespace('applyProduct');

@Component({
  name: 'WithdrawalPopUp',
})
export default class WithdrawalPopUp extends Vue {
  @Model('change', {
    type: Boolean,
  })
  isVisiblePopup!: boolean;

  @ApplyProductStore.State amount!: string;

  @ApplyProductStore.State usage!: LoanUsageOption;

  @ApplyProductStore.State usageList!: LoanUsageOption[];

  @ApplyProductStore.State channel!: ApplyChannelData;

  @ApplyProductStore.State selectRightInCapital!: ProductCapitalItem | null;

  @ApplyProductStore.State contracts!: Commodity[];

  @ApplyProductStore.Action $updateState!: (data: Dictionary) => void;

  private isWithdrawalPopup = false

  private currentUsageIndex = 0

  // 到达过最底部
  private arriveBottom = false;

  // 显示格式化的金额
  private get showAmount(): string {
    return String(this.amount).replace(/(\d)(?=(?:\d{3})+($|\.))/g, '$1,');
  }

  // 关闭
  private onClosedPopup() {
    this.$ubtPageButton(
      'finance_withdrawalAgreement_close',
      '产品',
      this.channel.productId,
    );
    this.$emit('close');
  }


  // 日常消费
  private onCheckUsing() {
    this.$ubtPageButton(
      '臻有钱_提现申请_选择提现用途',
      '产品',
      this.channel.productId,
    );
    this.isWithdrawalPopup = true;
  }

  // 选择提现用途项
  private onSelectName(usage: LoanUsageOption, index: number) {
    this.currentUsageIndex = index;
    this.$updateState({
      usage,
    });
    this.onBackCurrentDialog();
  }

  // 回退
  private onBackCurrentDialog() {
    this.isWithdrawalPopup = false;
  }

  private hideWithdrawalPopup() {
    this.$emit('change', false);
  }

  @Watch('isVisiblePopup')
  private watchShowScrollBottom(val: string) {
    if (val) {
      this.$nextTick(() => {
        this.listenerPageBottom();
      });
    }
  }

  // 监听滚动到页底
  private listenerPageBottom() {
    this.arriveBottom = false;
    const scrollBoxDom = document.querySelector('#scrollBoxDom') as HTMLElement;
    // 新增页面滑动埋点
    this.$ubtPageButton(
      'finance_agreementSlide',
    );
    scrollBoxDom.addEventListener('scroll', () => {
      const { scrollHeight, clientHeight, scrollTop } = scrollBoxDom;
      if (scrollHeight - clientHeight <= (scrollTop + 10)) {
        this.arriveBottom = true;
        // 新增页面滑动到底部 埋点
        this.$ubtPageButton(
          'finance_agreementSlideEnd',
        );
      }
    });
  }

  private track() {
    this.$ubtPageButton(
      '提现确认_同意确认提现',
      'commodityId',
      this.channel.productId,
    );
  }

  // 滚动到页底
  private scrollToBottom() {
    if (!this.arriveBottom) {
      const contractBtn = this.$refs.contractBottom as Element;
      contractBtn.scrollIntoView({ behavior: 'smooth' });
      this.arriveBottom = true;
    }
  }

  // 同意
  private onConfrim() {
    // 检测协议展示是否异常，防止极端情况协议弹窗未弹出时切换渠道导致的空白协议提交
    if (this.isContractDisplayAbnormal()) {
      Toast('协议展示异常，请关闭弹窗重新提交订单');
      return;
    }

    this.track();
    this.$emit('confirm', () => {
      /**
       * 延迟200ms关闭弹窗，避免提交订单接口还未展示loading，用户可以点击底部“提交”按钮，导致时序问题
       * 详细问题请阅：https://metis2.hellobike.cn/browse/SKXDZC-7140
       */
      setTimeout(() => {
        this.hideWithdrawalPopup();
      }, 200);
    });
  }

  /**
   * 检测协议展示是否异常，防止极端情况协议弹窗未弹出时切换渠道导致的空白协议提交
   */
  private isContractDisplayAbnormal(): boolean {
    // 2. 检查多资方协议数据结构 - 所有contract都无效才返回true
    const hasValidContract = this.contracts.some(
      (
        contract,
      ) => contract.productName || (contract.contractList && contract.contractList.length > 0),
    );

    if (!hasValidContract) {
      return true;
    }

    return false;
  }

  private render() {
    return this.isVisiblePopup && (
      <div class={style.multiChannels}>
        <Popup
          v-model={this.isVisiblePopup}
          class={style.popupRadius}
          position='bottom'
          closeOnClickOverlay={false}
        >
          <section class={style.mainContent}>
            <div class={style.navContent}>
              <div class={style.title}>
                <span>确认提现</span>
                <span class={style.closed} onClick={this.onClosedPopup.bind(this)}></span>
              </div>

              <div class={style.tipsTitle}>
                <div class={style.subTitle}>提现金额</div>
                <div class={style.moneyText}>
                  <span>¥</span>
                  <span class={style.moneyAmount}>{this.showAmount ? `${this.showAmount}` : ''}</span>
                </div>
                <div class={style.contractText}>
                  <div class={style.partialLoanTip}>
                    {shouldShowPartialLoanTip(this.channel) ? (
                      <span class={style.partialText}>实际金额以放款为准,</span>
                    ) : (
                      <span class={style.text}>请不要去投资房产与炒股,</span>
                    )}
                    <span class={style.text}>我承诺以上收款用于</span>
                  </div>
                  <div class={style.contractName}>
                    <span onClick={this.onCheckUsing.bind(this)}>{(this.usage && this.usage.name) || '个人日常消费'}</span>
                    <span></span>
                  </div>
                </div>
              </div>
            </div>
            <div class={style.contractContent} id={'scrollBoxDom'}>
              <MultiChannelContracts
                channelList={this.contracts}
              />
              <div ref="contractBottom" />
            </div>

            {!!this.contracts.length
              && <footer class={style.confirmButton}>
                  <ForceReadBtn
                  buttonType={ButtonTypeEnum.newApply}
                  showScrollBottom={!this.arriveBottom}
                  needCountDownNum={true}
                  onScrollToBottom={this.scrollToBottom.bind(this)}
                  onSubmit={this.onConfrim.bind(this)}
                ></ForceReadBtn>
              </footer>
            }
          </section>

          {/* 日常消费提现 */}
         <div class={[style.usingPart, this.isWithdrawalPopup && style.transform]}>
           <div class={style.usageContent}>
            <div class={style.usingTitle}>
                <span>请选择提现用途</span>
                <span class={style.back} onClick={this.onBackCurrentDialog.bind(this)}></span>
              </div>

              <div class={style.selectUsage}>
                {
                  this.usageList.map((item, index) => (<div
                    class={[style.usingContent, 'Hairline', this.currentUsageIndex === index && style.active]}
                    key={item.code}
                    onClick={() => this.onSelectName(item, index)}>
                  <span>{item.name}</span>
                  <span class={style.right} v-show={this.currentUsageIndex === index }></span>
                </div>))
                }
              </div>

            </div>
          </div>
        </Popup>
      </div>
    );
  }
}
